export class HabitCategoryModel {
    public HabitCategoryId:number;
    public HabitCategoryName:string;
    public HabitCategoryAutoComplete:any;
    public HabitCategorylist:HabitCategoryModel[];
}
